import { render, staticRenderFns } from "./ContractorRegionList.vue?vue&type=template&id=2a56d7f4"
import script from "./ContractorRegionList.vue?vue&type=script&lang=js"
export * from "./ContractorRegionList.vue?vue&type=script&lang=js"
import style0 from "./ContractorRegionList.vue?vue&type=style&index=0&id=2a56d7f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports